import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import moment from 'moment';
import { Batch } from '../../../constants';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-earnings-tab',
  standalone: true,
  imports: [CommonModule, MessageModule],
  templateUrl: './earnings-tab.component.html',
  styleUrls: ['./earnings-tab.component.scss']
})
export class EarningsTabComponent {
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  completedBatches = this.firebaseFirestoreService.getCompletedBatches();
  completedBatchesCount = 0;
  totalEarnings = 0;
  totalEarningsThisWeek = 0;
  totalEarningsThisMonth = 0;
  totalEarningsThisYear = 0;
  totalEarningsToday = 0;
  totalEarningsYesterday = 0;

  recentTransactions: Batch[] = [];

  constructor() {
    this.calculateEarnings();
  }

  calculateEarnings() {
    this.completedBatches.subscribe((batches) => {
      console.log(batches);
      this.completedBatchesCount = batches.length;

      this.totalEarnings = batches.reduce((acc, batch) => acc + (batch.actualShopperPay || batch.estimatedShopperPay || 0), 0);

      this.totalEarningsToday = batches
        .filter((batch) => {
          if (!batch.completedAt) return false;
          return moment(batch.completedAt).isSame(moment(), 'day');
        })
        .reduce((acc, batch) => acc + (batch.actualShopperPay || batch.estimatedShopperPay || 0), 0);

      this.totalEarningsYesterday = batches
        .filter((batch) => {
          if (!batch.completedAt) return false;
          return moment(batch.completedAt).isSame(moment().subtract(1, 'day'), 'day');
        })
        .reduce((acc, batch) => acc + (batch.actualShopperPay || batch.estimatedShopperPay || 0), 0);

      this.totalEarningsThisWeek = batches
        .filter((batch) => {
          if (!batch.completedAt) return false;
          return moment(batch.completedAt).isSame(moment(), 'week');
        })
        .reduce((acc, batch) => acc + (batch.actualShopperPay || batch.estimatedShopperPay || 0), 0);

      this.totalEarningsThisMonth = batches
        .filter((batch) => {
          if (!batch.completedAt) return false;
          return moment(batch.completedAt).isSame(moment(), 'month');
        })
        .reduce((acc, batch) => acc + (batch.actualShopperPay || batch.estimatedShopperPay || 0), 0);

      this.totalEarningsThisYear = batches
        .filter((batch) => {
          if (!batch.completedAt) return false;
          return moment(batch.completedAt).isSame(moment(), 'year');
        })
        .reduce((acc, batch) => acc + (batch.actualShopperPay || batch.estimatedShopperPay || 0), 0);

      this.recentTransactions = batches.sort((a, b) => (b.completedAt || 0) - (a.completedAt || 0)).slice(0, 5) as Batch[];
    });  
  }
} 